/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/**
 * Scenario feature related request structures are defined here
 */
const API = {
  GET_SCENARIOS: {
    path: '/organizations/:organizationId/scenarios?:query',
    method: 'GET',
  },
  POST_SCENARIOS: {
    path: '/organizations/:organizationId/scenarios',
    method: 'POST',
  },
  DELETE_SCENARIO: {
    path: '/organizations/:organizationId/scenarios/:id',
    method: 'DELETE',
  },
  PATCH_SCENARIO: {
    path: '/organizations/:organizationId/scenarios/:scenarioId',
    method: 'PATCH',
  },
  GET_SCENARIO_BY_ID: {
    path: '/organizations/:organizationId/scenarios/:selectedScenarioId',
    method: 'GET',
  },
  GET_REPORTS: {
    path: '/organizations/:organizationId/reports',
    method: 'GET',
  },
  GET_REPORT_PAGES: {
    path: '/organizations/:organizationId/reports/:reportId/pages',
    method: 'GET',
  },
  GET_VISUALS: {
    path: '/organizations/:organizationId/visuals?:query',
    method: 'GET',
  },
  GET_VISUAL_FILTERS: {
    path: '/organizations/:organizationId/visual-filters?:query',
    method: 'GET',
  },
  GET_ALL_HOTELS: {
    path: '/organizations/:organizationId/hotels?:query',
    method: 'GET',
  },
  GET_ALL_BREAKDOWNS: {
    path: '/organizations/:organizationId/breakdowns?:query',
    method: 'GET',
  },
};
//
export default API;

export const MAX_FILTERS = 10;

export const FILTER_OPTIONS = [
  { label: 'Stay Date', value: 'stayDate' },
  { label: 'Focus on', value: 'focusOn' },
  { label: 'Hotel', value: 'hotel' },
  { label: 'Booking Pace Horizon', value: 'bookingPaceHorizon' },
  { label: 'Percentage', value: 'percentage' },
  { label: 'Booking Date', value: 'bookingDate' },
  { label: 'Breakdown', value: 'breakdown' },
  { label: 'Hotel Set', value: 'hotelSet' },
  { label: 'Comparison Period', value: 'comparisonPeriod' },
  { label: 'Comparison Alignment', value: 'comparisonAlignment' },
];

export const FILTER_TYPES = {
  DATE_RANGE: 'dateRange',
  BREAKDOWN: 'breakdown',
  FOCUS_ON: 'focusOn',
  HOTEL: 'hotel',
  BOOKING_PACE_HORIZON: 'bookingPaceHorizon',
  COMPARISON_PERIOD: 'comparisonPeriod',
  COMPARISON_ALIGNMENT: 'comparisonAlignment',
  PERCENTAGE: 'percentage',
  TEXT: 'text',
};

export const FILTER_CONFIG = {
  stayDate: {
    label: 'Stay Date',
    type: FILTER_TYPES.DATE_RANGE,
    fields: [
      { name: 'startDate', label: 'Start Date', type: 'date' },
      { name: 'endDate', label: 'End Date', type: 'date' },
    ],
  },

  focusOn: {
    label: 'Focus On',
    type: FILTER_TYPES.FOCUS_ON,
    fields: [
      { name: 'breakdownName', label: 'Breakdown Name', type: 'text' },
      { name: 'values', label: 'Values', type: 'textArray' },
    ],
  },

  hotel: {
    label: 'Hotel',
    type: FILTER_TYPES.HOTEL,
  },

  hotelSet: {
    label: 'Hotel Set',
    type: FILTER_TYPES.HOTEL,
  },

  breakdown: {
    label: 'Breakdown',
    type: FILTER_TYPES.BREAKDOWN,
  },

  percentage: {
    label: 'Percentage Filter',
    type: FILTER_TYPES.PERCENTAGE,
  },

  bookingPaceHorizon: {
    label: 'Booking Pace Horizon',
    type: FILTER_TYPES.BOOKING_PACE_HORIZON,
  },

  comparisonPeriod: {
    label: 'Comparison Period',
    type: FILTER_TYPES.COMPARISON_PERIOD,
  },

  comparisonAlignment: {
    label: 'Comparison Alignment',
    type: FILTER_TYPES.COMPARISON_ALIGNMENT,
  },

  bookingDate: {
    label: 'Booking Date',
    type: FILTER_TYPES.DATE_RANGE,
    fields: [
      { name: 'startDate', label: 'Start Date', type: 'date' },
      { name: 'endDate', label: 'End Date', type: 'date' },
    ],
  },
};

export const DATE_RANGE_DROPDOWN_VALUES = [
  'Today',
  'This Week',
  'This Month',
  'Past Days',
  'Past Weeks',
  'Past Months',
  'Next Days',
  'Next Weeks',
  'Next Months',
  'Custom Date Range',
];

export const FUTURE_PAST_OPTIONS = [
  'Past Days',
  'Past Weeks',
  'Past Months',
  'Next Days',
  'Next Weeks',
  'Next Months',
];

export const COMPARISON_PERIOD_DROPDOWN_VALUES = [
  'Previous Week',
  'Previous Month',
  'Previous Year',
  'OTB',
  'Custom',
];

/**
 * Tags for Visual Filter classification are defined here
 */
export const TAGS = {
  PACE_HORIZON: 'PACE_HORIZON',
  TREND: 'TREND',
  PERCENTAGE: 'PERCENTAGE',
  DATE_COMPARISON: 'DATE_COMPARISON',
};
